import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import ajaxGym from '../../util/remote/ajaxGym';
import ActivityLoader from '../Common/ActivityLoader';
import TextInput from '../Common/TextInput';
import { useBalance } from '../../DataStore/BalanceContext';
import Notification from '../Common/Notification';
import { useGym } from '../../DataStore/Gym/GymContext';

const PayCommissionModal = ({ show, onClose, trainer }) => {
  const [amount, setAmount] = useState("");
  const [reference, setReference] = useState('');
  const [paymentAccount, setPaymentAccount] = useState("");
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  
  const { getCashBankListing, cashBankListing } = useBalance();
  const {getCommissionBalances, getTrainerList} = useGym();

  useEffect(()=>{
    getCashBankListing();
  }, [])
  
  const handlePayment = async() =>{

    if (!amount || isNaN(amount)) {
      setNotify(<Notification type='danger' message='Please enter a valid amount' />);
      return;
    }

    setLoading(true);
    const server_response = await ajaxGym.payTrainerCommission({
      trainer_id: trainer.id,
      amount: amount,
      reference: reference,
      payment_account: paymentAccount?.value,
    });
    setLoading(false);
    if (server_response.status === "OK") {
      setNotify(<Notification type='success' message={server_response.message} />);
      getCommissionBalances();
      getTrainerList();
      setAmount("");
      setTimeout(() => {
        closeModal();
      }, 1200);
    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);

    }

  }

  const closeModal = () => {
    setReference("");
    setNotify(null);
    onClose();
  };

  const RenderAccountField = () => {
    const options = [];
    if (Array.isArray(cashBankListing)) {
      cashBankListing.map((item, key) =>
        options.push({
          label: item.account_number + " " + item.account_name,
          value: item.account_id,
        })
      );
    }
    return (
      <TextInput
        label="Cash Account"
        type="select"
        leftIcon="fa fa-university"
        placeholder={paymentAccount.label || "Select account..."}
        options={options}
        onChange={(item) => setPaymentAccount(item)}
        leftComponent={<i className="fa fa-university" onClick={() => getCashBankListing(true)}></i>}
        loading={!cashBankListing}
      />
    );
  };

  return (
    <BsModal
      show={show}
      onClose={closeModal}
      title="Pay Trainer Commission"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !amount || !reference}
            onClick={handlePayment}
          >
            <i className="fa fa-check-circle mr-1"></i> Pay Now
          </button>
        </>
      }
    >
      <div className="d-flex align-items-center mb-3 p-2 rounded bg-light shadow-sm">
        <img
          src={trainer?.photo || 'assets/images/avatars/default.png'}
          alt={trainer?.full_name}
          className="rounded-circle mr-3"
          style={{ width: 50, height: 50, objectFit: 'cover' }}
        />
        <div>
          <h5 className="mb-0">{trainer?.full_name}</h5>
          <small className="text-muted">{trainer?.phone_number || 'No phone provided'}</small><br/>
          <small className="text-dark">Amount Due: {trainer?.commission_balance}</small>

        </div>
      </div>

            <TextInput
                type="number"
                label="Amount Paid"
                placeholder="Enter amount paid"
                leftIcon="fa fa-money-bill"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                required
              />
              {RenderAccountField()}
              <TextInput
                type="text"
                label="Reference"
                placeholder="Transaction Ref"
                leftIcon="fa fa-hashtag"
                value={reference}
                onChange={e => setReference(e.target.value)}
                required
              />


        {loading && <ActivityLoader />}
        {notify}
    </BsModal>
  );
};

export default PayCommissionModal;
